









import { Component, Vue, Watch } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
@Component({
  components: {
    PageTitle,
    AdminIframe,
  },
})
export default class SubscriptionChangeNotificationIframe extends Vue {
  private remoteSrc = '';
  private title = '';

  @Watch('$route.params.action')
  private setRemoteSrc() {
    const { query, params: { action } } = this.$route;

    const actionText = (() => {
      switch (action) {
        case 'registration':
          return '등록';
        case 'modification':
          return '수정';
        case 'responses':
          return '응답 조회';
        default:
          return '관리';
      }
    })();

    this.title = `정기결제(배송) 변경 동의 ${actionText}`;

    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + `/fulfillment/order/subscription-change-notification/${action}?${queryString}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
